var DFTlrd = DFTlrd || {};

DFTlrd.SponsorModal = function() {

    const $modal = $('#sponsor-modal');
    const modal = $('#sponsor-modal').length ? new bootstrap.Modal($modal[0]) : null;

    var _init = function() {
        if (modal) {
            $('.sponsor-modal-link').on('click', _handleSponsorModalLinkClick);
            // stop video when modal is closed
            $modal.on('hide.bs.modal', _handleModalClose);
        }
    }

    var _handleSponsorModalLinkClick = function(e) {

        e.preventDefault();

        let $link = $(this);
        let sponsor = $link.data('sponsor');

        _updateModal(sponsor);

    }

    var _handleModalClose = function(e) {
        var $video = $modal.find('video');
        $video[0].pause();
    }

    var _updateModal = function(sponsor) {
        // update modal title
        $modal.find('.modal-title').text(sponsor.name);
        // add video to modal body
        let videoHTML = '';
        videoHTML += '<div class="ratio ratio-16x9">'
            videoHTML += '<video controls playsinline>';
                videoHTML += '<source src="' + sponsor.video + '" type="video/mp4">';
            videoHTML += '</video>';
        videoHTML += '</div>';
        $modal.find('.modal-body').html(videoHTML);
        // show modal
        modal.show();
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
    };

}();

$(function() {
    DFTlrd.SponsorModal.init();
});
